import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import FAQAccordion from "@/components/FAQAccordion";
import { useLang } from "@/context/LanguageContext";
import { useData } from "@/context/DataContext";
import { openWa } from "@/lib/wa";

export default function About() {
  const { t, pick } = useLang();
  const { settings, faqs } = useData();
  const features = settings?.features || [];

  return (
    <main>
      <SEO title="من نحن | ميرو للإطارات وخدمات السيارات" description="ميرو للإطارات وخدمات السيارات علامة متخصصة في معلومات وخدمات الإطارات والعجلات وحساسات ضغط الإطارات وخدمات السيارات المتنقلة في الرياض." path="/about" />
      <PageHero eyebrow="ABOUT MERO" title={t("about.title")} sub={pick("ميرو للإطارات وخدمات السيارات", "MERO Tires & Auto Services")} />

      <section className="pb-16">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <Reveal>
            <div className="space-y-6 text-base leading-9 text-zinc-300" data-testid="about-body">
              <p>ميرو للإطارات وخدمات السيارات هي علامة متخصصة في تقديم معلومات وخدمات مرتبطة بالإطارات والعجلات وحساسات ضغط الإطارات وخدمات السيارات المتنقلة.</p>
              <p>نهدف إلى تسهيل وصول العميل إلى الخدمة المناسبة من خلال تجربة إلكترونية واضحة، واستفسار مباشر، وخطوات طلب بسيطة.</p>
              <p>يمكنك التواصل مع ميرو للاستفسار عن الخدمة المناسبة لسيارتك، والتحقق من التوفر والتكلفة قبل التنفيذ.</p>
            </div>
          </Reveal>
          <Reveal className="mt-10">
            <button onClick={() => openWa()} className="btn-wa" data-testid="about-wa-cta"><MessageCircle size={18} /> {t("about.wa")}</button>
          </Reveal>
        </div>
      </section>

      <section className="border-t border-white/5 bg-coal/40 py-16">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <SectionHeading eyebrow={{ ar: "مميزات الخدمة", en: "Service features" }} title={{ ar: "ما يميز تجربة ميرو", en: "What makes the MERO experience different" }} />
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {features.map((f, i) => (
              <Reveal key={i} delay={i % 3}>
                <div className="h-full rounded-3xl border border-white/10 bg-ink/70 p-7">
                  <h3 className="text-base font-bold text-gold">{pick(f.ar, f.en)}</h3>
                  <p className="mt-3 text-sm leading-7 text-mist">{pick(f.desc_ar, f.desc_en)}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <SectionHeading center eyebrow={{ ar: "الأسئلة الشائعة", en: "FAQ" }} title={{ ar: t("faq.title"), en: t("faq.title") }} sub={{ ar: t("faq.sub"), en: t("faq.sub") }} />
          <FAQAccordion items={(faqs || []).slice(0, 6).map((f) => ({ q: pick(f.q_ar, f.q_en), a: pick(f.a_ar, f.a_en) }))} />
          <Reveal className="mt-8 text-center">
            <Link to="/faq" className="btn-ghost">{t("cta.viewAll")}</Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
